import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DirectionService } from '../../direction.service';
import { AuthService } from 'src/app/auth/auth.service';
import { DialogService } from 'src/app/dialog/dialog.service';

import { ClustersService } from 'src/app/main-section/choose-branch/clusters.service';
import { openAnydeskId } from 'src/app/utils/open-anydesk';

@Component({
  selector: 'app-su-all-screens',
  templateUrl: './su-all-screens.component.html',
  styleUrls: ['./su-all-screens.component.css'],
  host: {
    class: 'fill-screen-modal-new-dialog'
  }
})
export class SuAllScreensComponent implements OnInit, OnDestroy {
  isRTL: boolean = true;
  private directionSubscription: Subscription;
  isDarkMode: boolean = false;
  isLoading: boolean = false;

  userId: string;
  userIsAuthenticated = false;
  private authStatusSub: Subscription;

  clusters: any[] = [];

  constructor(
    private directionService: DirectionService,
    private authService: AuthService,
    private dialogService: DialogService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clustersService: ClustersService,
  ) { }

  async ngOnInit() {
    this.isLoading = true;
    this.directionSubscription = this.directionService.direction$.subscribe(direction => {
      this.isRTL = direction === 'rtl';
    });

    this.directionService.isDarkMode$.subscribe(isDarkMode => {
      this.isDarkMode = isDarkMode;
    });

    this.userId = this.authService.getUserId();
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe(isAuthenticated => {
        this.userIsAuthenticated = isAuthenticated;
        this.userId = this.authService.getUserId();
      });

    this.clustersService.clustersformaniger().subscribe((clusters) => {
      this.clusters = clusters;
      console.log('clusters', clusters);
      this.isLoading = false;
    });
  }

  closeSuAllScreensDialog() {
    this.dialogService.onClosSuAllScreensDialog();
  }

  ngOnDestroy() {
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
    if (this.authStatusSub) {
      this.authStatusSub.unsubscribe();
    }
  }

  getScreenImageUrl(service: string, branch: any): string {
    let imageUrl = '';
    if (service === 'plotter') {
      if (branch.printers && branch.printers[0]?.ip) {
        imageUrl = "https://www.eazix.co.il/img.php?i=http://" + branch.printers[0].ip + ":5000/screen";
      }
    } else if (service === 'express') {
      if (branch.status?.image) {
        imageUrl = branch.status.image;
      }
    }
    return imageUrl;
  }

  openAnydesk(service: string, branch: any) {
    let anydesk = '';
    if (service === 'plotter') {
      if (branch.printers && branch.printers[0]?.anydesk) {
        anydesk = branch.printers[0].anydesk;
      }
    } else if (service === 'express') {
      if (branch.properties?.anydesk) {
        anydesk = branch.properties.anydesk;
      }
    }
    if (anydesk) {
      void openAnydeskId(anydesk);
    } else {
      console.error('Anydesk link is not available.');
    }
  }
  // ===============
}
